export default "__VITE_PUBLIC_ASSET__a943277d__"